import { UPDATE_ACTIVE_CARD } from '../types';
import getCardInfo from '../utility/getCardInfo';

export default function updateActive(card) {
  if (!card) {
    return {
      activeCard: null,
      type: UPDATE_ACTIVE_CARD,
    };
  }

  let activeCard;

  if (typeof card === 'string') {
    activeCard = {
      cardHolder: undefined,
      id: undefined,
      ...getCardInfo(card),
    };
  } else {
    activeCard = card;
  }

  return {
    activeCard,
    type: UPDATE_ACTIVE_CARD,
  };
}
